import { SvgIcon } from "@mui/material";

import type { SvgIconProps } from "@mui/material";
import type { FC } from "react";

export const WhatsAppIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 72 72">
    <path
      d="M36 6C19.4317 6 6 19.4317 6 36C6 41.4508 7.45417 46.5625 9.995 50.9675L6 66L21.585 62.3158C25.8633 64.6642 30.775 66 36 66C52.5683 66 66 52.5683 66 36C66 19.4317 52.5683 6 36 6ZM36 60.6267C30.9858 60.6267 26.3225 59.1283 22.4317 56.5542L13.2242 58.8992L15.8067 50.0983C13.0125 46.1042 11.3733 41.2433 11.3733 35.9992C11.3733 22.3983 22.3992 11.3725 36 11.3725C49.6008 11.3725 60.6267 22.3983 60.6267 35.9992C60.6267 49.6 49.6008 60.6267 36 60.6267Z"
      fill="#25D366"
    />
    <path
      d="M43.0292 39.96L50.2875 43.3817C50.6208 43.5383 50.8342 43.8767 50.8042 44.2433C50.7258 45.1983 50.3425 47.1125 48.6267 48.8283C43.7833 53.6717 35.0858 48.1917 34.7317 47.98C32.5925 46.8308 30.56 45.2933 28.6325 43.3667C26.7058 41.44 25.1675 39.4067 24.0183 37.2675C23.8058 36.9142 18.3258 28.2167 23.17 23.3725C24.8858 21.6567 26.8 21.2733 27.755 21.195C28.1225 21.165 28.46 21.3783 28.6167 21.7117L32.0392 28.97C32.2008 29.3133 32.13 29.7217 31.8617 29.99L29.3108 32.5408C28.7592 33.0925 28.5975 33.9517 28.9775 34.6333C29.9083 36.3025 31.16 37.91 32.61 39.3892C34.0892 40.8392 35.6967 42.0917 37.3658 43.0217C38.0475 43.4017 38.9058 43.24 39.4583 42.6883L42.0092 40.1375C42.2775 39.8692 42.6858 39.7975 43.0292 39.96Z"
      fill="#25D366"
    />
  </SvgIcon>
);
